module.exports = __webpack_public_path__ + "static/media/logo.21ba12a5.png";